import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IoIosAdd, IoMdCreate } from 'react-icons/io';

import { SidebarHeader, ScrollableBox, NavBackButton, Feature } from '@mssgme/ui';
import { ProductsListDraggable, ProductsListFooter, AdminHeaderSearch } from '../UI';
import { useProductsMain } from '../hooks';
import { PageLayout } from '../../../../UI';

import styles from './PageProducts.scss';

export default function PageProducts() {
    const { t } = useTranslation('cards');
    const match = useRouteMatch();
    const collectionId = match.params.id;
    const { collection, products, setFilter, loadMore } = useProductsMain((col) => col._id === collectionId);

    const leftButton = <NavBackButton to="/p/products/collections" />;
    const rightButton = (
        <div className={styles.headerBtns}>
            <Link
                className={styles.headerLink}
                to={`/p/products/collections/edit/${collectionId}`}
                title={t('PageProductCollections.tipEditCollection')}
            >
                <IoMdCreate size={22} color="#000" />
            </Link>
            <Link
                className={styles.headerLink}
                to={`/p/products/new/${collectionId}`}
                title={t('pageProducts.tipAddProduct')}
            >
                <IoIosAdd size={34} color="#000" />
            </Link>
        </div>
    );

    return (
        <PageLayout className={styles.root}>
            <SidebarHeader
                heading={collection.name}
                leftButton={leftButton}
                rightButton={rightButton}
                style={{ boxShadow: 'none' }}
            />
            <ScrollableBox nopadding onBottomScroll={loadMore}>
                <Feature rule="products:?">
                    <AdminHeaderSearch onChange={setFilter} value={products.filter.name} />
                    <div>
                        {collection && (
                            <ProductsListDraggable
                                collectionId={collectionId}
                                products={products.items}
                                draggable={products.filter.name === ''}
                            />
                        )}
                    </div>

                    <ProductsListFooter products={products} loadMore={loadMore} />
                </Feature>
            </ScrollableBox>
        </PageLayout>
    );
}
